import React, { useMemo } from "react";
import "./TourActivityList.css";
import { Base64 } from "js-base64";
import { LazyLoadImage } from "react-lazy-load-image-component";
import moment from "moment";
import { constant } from "../Component/AdminPackageDetails/PackageShowcase/commonFunction";
import PreferredTagComponent from "../Component/PreferredTagComponent";

function TourListPackage({
  tour_data: {
    id,
    selling_price: rawSellingPrice,
    discount_percentage: rawDiscountPercentage,
    price: rawPrice,
    package_name,
    package_image,
    location,
    no_days,
    guest_combination,
    package_description,
    // package_open_date,
    package_close_date,
    start_date,
    end_date,
    preferred
  },
  dateSelected,
  defaultZonevalPackageVal
}) {
  const packageDescription = package_description
    ? package_description.replace(/<[^>]+>/g, "").substring(0, 50)
    : "";

  const guest = JSON.parse(guest_combination);
  const guestCount = guest.reduce(
    (guest, item) => ({
      adult: guest.adult + parseInt(item.adultCounter),
      child: guest.child + parseInt(item.childCounter),
      room: guest.room + parseInt(item.roomCounter),
    }),
    { adult: 0, child: 0, room: 0 }
  );

  const getAmount = useMemo(() => {
    const selling_price = parseFloat(rawSellingPrice) || 0;
    const discount_percentage = parseFloat(rawDiscountPercentage) || 0;
    const price = parseFloat(rawPrice) || 0;

    return (
      <div>
        <small className="d-block text-black fw-bold">from</small>
        {parseFloat(discount_percentage) > 0 && (
          <p className="text-muted fw-bold">
            <s>{constant.amountWithCurrency(price)}</s>{" "}
            <small className="badge bg-danger rounded-pill fw-bold">
              {discount_percentage}% OFF
            </small>
          </p>
        )}
        <h5 className="card-title fw-bold mb-0 text-black">{constant.amountWithCurrency(selling_price)}</h5>
        <small className="text-black">Excluding applicable taxes</small>
      </div>
    );
  }, [rawSellingPrice, rawDiscountPercentage, rawPrice]);

  let startDate = moment(start_date);
  let endDate = moment(end_date);
  let diff = endDate.diff(startDate);
  let diffDuration = moment.duration(diff);
  let TotalDays = diffDuration.days();

  let result = [];
  const startDateNew = new Date(start_date);
  const endDateNew = new Date(end_date);
  const numberOfLocation = location.length;

  // Calculate the total number of days in the range
  const totalDays = (endDateNew - startDateNew) / (1000 * 60 * 60 * 24);

  // Divide the range into four equal parts
  let daysPerPart = Math.floor(totalDays / numberOfLocation);
  let reminder = totalDays % numberOfLocation;

  // Initialize an array to store the results
  const dividedRanges = [];

  location.map((location, index) => {
    let numberDay = "";

    if (TotalDays % numberOfLocation == 0) {
      numberDay = TotalDays / numberOfLocation;
    } else {
      numberDay = TotalDays % numberOfLocation;
    }

    let DateMain = [];
    const partStartDate = new Date(startDateNew);
    const partEndDate = new Date(partStartDate);
    // Calculate the end date for the current part
    partEndDate.setDate(partEndDate.getDate() + daysPerPart);
    // If there's a reminder, distribute it across the parts
    if (reminder > 0) {
      partEndDate.setDate(partEndDate.getDate() + 1);
      reminder--;
    }
    // Store the calculated part in the results array
    let startDateNewData = moment(partStartDate);
    let endDateNewData = moment(partEndDate);
    let diffNewDataNew = endDateNewData.diff(startDateNewData, "days");
    DateMain.push({
      number: diffNewDataNew,
      startDate: moment(partStartDate).format("Y-MM-DD"),
      endDate: moment(partEndDate).format("Y-MM-DD"),
      indexid: index,
    });

    dividedRanges.push({
      number: diffNewDataNew,
      startDate: moment(partStartDate).format("Y-MM-DD"),
      endDate: moment(partEndDate).format("Y-MM-DD"),
      indexid: index,
    });
    // Update the start date for the next part
    startDateNew.setDate(partEndDate.getDate());

    let newData = {
      Id: location.location,
      Location: { label: location.location },
      name: diffNewDataNew,
      range: DateMain,
    };
    result.push(newData);
  });

  const treeData = [
    {
      cat: JSON.parse(guest_combination),
      Planname: `${location
        .map((list) => JSON.stringify(list?.location))
        .join(", ")} - (${moment(start_date).format("ddd, DD MMM Y")} - ${moment(
          end_date
        ).format("ddd, DD MMM Y")})`,
      range: [{ startDate: start_date, endDate: end_date }],
      numberOfDay: no_days,
      numberOfLocation: location.length,
      children: result,
    },
  ];

  return (
    <div className="Container-Tile h-auto">
      <span class="position-absolute btn btn-sm btn-warning fw-bold mb-1 py-0">{no_days}N/{parseInt(no_days) + 1}D</span>
      <PreferredTagComponent preferred={preferred} />
      <a
        href={
          "/packageDetails?package_id=" +
          Base64.btoa(id) +
          "&name=" +
          encodeURIComponent(defaultZonevalPackageVal) +
          "&checkin=" +
          encodeURIComponent(start_date) +
          "&checkout=" +
          encodeURIComponent(end_date) +
          "&guestCombination=" +
          JSON.stringify(guest_combination) +
          "&itineraryPlan=" +
          encodeURIComponent(JSON.stringify(treeData)) +
          "&moreLocation=" +
          encodeURIComponent(defaultZonevalPackageVal) +
          "&dateselected=" +
          encodeURIComponent(dateSelected) +
          "&package_name=" +
          encodeURIComponent(package_name)
        }
      >
        <div className="Image-Section pt-0 border-0">
          <LazyLoadImage
            src={package_image}
            className="w-100"
            style={{ objectFit: "cover" }}
            placeholderSrc={
              process.env.PUBLIC_URL + "images/placeholder.png"
            }
          />
        </div>
        <div className="Text-Section justify-content-end">
          <div className="Text-Contents">
            <div className="Text-Ratings">
              <p
                className="latoBlack font16 blackText appendBottom12"
                style={{ marginRight: 10 }}
              >
                <span>{package_name.substring(0, 80)}</span>
              </p>
            </div>

            <div className="Small-Text">
              <p className="text-muted">
                {location.map(({ number, location }) => `${number}N ${location}`).join(", ")}
              </p>

              {packageDescription && (
                <p
                  className="fst-italic"
                  style={{
                    fontSize: "12px",
                    color: "#000",
                    textAlign: "justify",
                    marginRight: 15,
                  }}
                >
                  {packageDescription +
                    (packageDescription.length > 50 ? "..." : "")}
                </p>
              )}
              {/* <p>
                <span className="fw-bold">Number of days: </span>
                {no_days}
              </p> */}
              <p className="border-top mt-2 pt-2">
                <span className="fw-bold">Guest Combination: </span>
                {guestCount.adult} Adults, {guestCount.child}{" "}
                Children
              </p>
              <p>
                <span className="fw-bold">Package available till </span>
                {moment(package_close_date).format("ddd, D MMM yy")}
              </p>
              {/* <p>
                <span className="fw-bold">Package close date: </span>
                {moment(package_close_date).format("ddd, D MMM yy")}
              </p> */}
            </div>
          </div>
          <div className="priceDetails textRight">
            <div className="padding20 column" style={{ marginTop: "0px" }}>
              {getAmount}
            </div>
          </div>
        </div>
      </a>
    </div>
  );
}

export default TourListPackage;
